
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DeviceType, AppModule } from "@/store/modules/app";
import { AppMain, Navbar, Sidebar } from "./components";
import ResizeMixin from "./mixin/resize";
import { UserModule } from "@/store/modules/user";
import Util from "@/lib/util";
@Component({
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar
  }
})
export default class extends mixins(ResizeMixin) {
  isEducation = UserModule.user.isEdcationUser

  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    };
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false);
  }
}
